module.exports = __webpack_public_path__ + "img/product_bg_01_sc_01.8a7b7d4.webp";